import React, { useEffect, useState } from 'react';

/**
 * Cal.com Embed Component
 * Embeds the Cal.com booking widget for workshop scheduling
 * Note: User has cal.eu account at https://app.cal.eu/humanistix/
 */
const CalEmbed = ({ 
  calLink = "humanistix", 
  calDomain = "app.cal.eu",  // Use cal.eu for EU accounts
  config = {},
  className = "",
  style = {}
}) => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    // For simplicity and reliability, use iframe embed
    setLoaded(true);
  }, []);

  if (error) {
    return (
      <div className="p-8 text-center">
        <p className="text-gray-600 mb-4">Unable to load booking calendar.</p>
        <a 
          href={`https://${calDomain}/${calLink}`}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 bg-blue-500 text-white px-6 py-3 rounded-lg hover:bg-blue-600 transition-colors"
        >
          Book on Cal.com →
        </a>
      </div>
    );
  }

  return (
    <div 
      className={`cal-embed-container ${className}`}
      style={{ 
        width: '100%', 
        height: '100%', 
        minHeight: '650px',
        overflow: 'hidden',
        ...style 
      }}
    >
      <iframe
        src={`https://${calDomain}/${calLink}?embed=true&theme=light`}
        width="100%"
        height="100%"
        frameBorder="0"
        style={{ minHeight: '650px', border: 'none' }}
        title="Book a workshop"
        allow="camera; microphone; fullscreen"
      />
    </div>
  );
};

/**
 * Cal.com Popup Button Component
 * Opens Cal.com in a new tab when clicked
 */
export const CalPopupButton = ({ 
  calLink = "humanistix",
  calDomain = "app.cal.eu",
  children,
  className = ""
}) => {
  const handleClick = () => {
    window.open(`https://${calDomain}/${calLink}`, '_blank');
  };

  return (
    <button onClick={handleClick} className={className}>
      {children}
    </button>
  );
};

export default CalEmbed;
